import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  getColor,
  Icons,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { DocDetailDto, DocInfo } from "../../types/files";
import Progress from "../Prgress";
import utilsCommon from "../../shared/utils/common";
import utilsDocs from "../../shared/utils/docs";
import DocAside from "../../components/DocAside";
import LeaveCommentModal from "../../components/More/LeaveCommentModal";
import { handleDocDownload, handleDocPreview } from "../../shared/utils/api";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import ReadRequestModal from "../../components/More/ReadRequestModal";
import usePolicyStore from "../../redux/dispatcher/usePolicyStore";
import { nanoid } from "@reduxjs/toolkit";
import ChangeWorkgroupFileAuthModal from "../../components/More/ChangeWorkgroupFileAuthModal";
import ChangeFileAuthModal from "../../components/More/ChangeFileAuthModal";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
const copy = require("clipboard-copy");

const ClientDocDetailModal = () => {
  const toast = useToast();
  const { t } = useTranslation();
  const params = useParams();

  const {
    documentState,
    getContentDetail,
    getContentFavorite,
    getContentDownload,
    getDocTimeline,
  } = useDocumentStore();
  const { getWorkgroupDetail } = useWorkgroupStore();
  const { getLinkFilePolicy } = usePolicyStore();
  const [syncId] = useState(params.syncId);
  const [documentInfo, changeDocumentInfo] = useState<DocDetailDto>();
  const [actionUrl, changeActionUrl] = useState("");
  const [modalType, changeModalType] = useState("CLOSE");
  useEffect(() => {
    if (syncId) {
      getContentDetail({ workgroupId: "NONE", syncId, type: "aside" }).then(
        (resp) =>
          getDocTimeline({
            workgroupId: "NONE",
            syncId,
          })
      );
    }
  }, [getContentDetail, syncId]);
  useEffect(() => {
    changeDocumentInfo(documentState.contentAsideDetail);
  }, [documentState.contentAsideDetail]);
  useEffect(() => {
    if (!documentInfo) return;
    getLinkFilePolicy({
      workgroupId: documentInfo?.documentInfo?.workgroup.workgroupId,
      syncId: documentInfo?.documentInfo?.syncId,
    }).then((resp: any) => {
      if (resp.payload.actionUrl) {
        changeActionUrl(resp.payload.actionUrl);
      }
    });
    getWorkgroupDetail({
      workgroupId: documentInfo?.documentInfo?.workgroup.workgroupId,
    });
  }, [documentInfo]);
  const handleCopyLink = () => {
    if (actionUrl) {
      copy(actionUrl);
      toast.toastMsg(nanoid(), t("file.link.copySuccess"), "success");
    }
  };
  return documentInfo ? (
    <Box width={800} height={690} direction="column" classes="clientDetail">
      {modalType === "READ_REQUEST" && (
        <ReadRequestModal
          open={modalType === "READ_REQUEST"}
          onClose={() => changeModalType("CLOSE")}
          docInfo={documentInfo.documentInfo}
        />
      )}
      {modalType === "SET_AUTH" &&
        (documentInfo.documentInfo.workgroup.workgroupId === "NONEWORKGROUP" ? (
          <ChangeFileAuthModal
            open={modalType === "SET_AUTH"}
            docInfo={documentInfo.documentInfo}
            onClose={() => changeModalType("CLOSE")}
            onClickAfterSubmit={() =>
              getContentDetail({
                workgroupId: "NONE",
                syncId: syncId ?? "",
                type: "aside",
              }).then((resp) =>
                getDocTimeline({
                  workgroupId: "NONE",
                  syncId: syncId ?? "",
                })
              )
            }
          />
        ) : (
          <ChangeWorkgroupFileAuthModal
            open={modalType === "SET_AUTH"}
            docInfos={[documentInfo.documentInfo]}
            onClose={() => changeModalType("CLOSE")}
            onClickAfterSubmit={() =>
              getContentDetail({
                workgroupId: "NONE",
                syncId: syncId ?? "",
                type: "aside",
              }).then((resp) =>
                getDocTimeline({
                  workgroupId: "NONE",
                  syncId: syncId ?? "",
                })
              )
            }
          />
        ))}
      <Box width={"100%"} minHeight={66}>
        {utilsDocs.renderDocIcon(documentInfo?.documentInfo.contentName, 40)}
        <Box direction="column" classes="mg ml-8" width={"calc(100% - 270px)"}>
          <Tooltip message={documentInfo?.documentInfo.contentName}>
            <Typography type="subtitle1" ellipsis>
              {documentInfo?.documentInfo.contentName}
            </Typography>
          </Tooltip>
          <Typography
            type="body4_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {`${utilsDocs.fileSizeFormat(
              documentInfo?.documentInfo.fileSize
            )} · ${utilsDocs.fileFormattoStr(
              documentInfo.documentInfo.contentName
            )}`}
          </Typography>
        </Box>
        {documentInfo?.documentInfo?.myPolicy?.uniqueId !== "ONLYVIEW" && (
          <Box classes="mg ml-auto clientDetail-header">
            {documentInfo.documentInfo.status === "N" && (
              <Tooltip
                message={
                  documentInfo.documentInfo?.favoritDate > 0
                    ? t("file.action.removeFav")
                    : t("file.action.addFav")
                }
              >
                <Button
                  btnStyle="icon"
                  onClick={() =>
                    getContentFavorite({
                      syncIds: [documentInfo.documentInfo?.syncId],
                      flag: documentInfo.documentInfo?.favoritDate <= 0,
                      page: "favorite",
                    })
                  }
                  leadingIcon={
                    !!documentInfo.documentInfo?.favoritDate &&
                    documentInfo.documentInfo?.favoritDate > 0 ? (
                      <Icons variant="fill" label="star" isColored size={20} />
                    ) : (
                      <Icons variant="line" label="star" isOn size={20} />
                    )
                  }
                />
              </Tooltip>
            )}
            {utilsCommon.checkMenuAvailble(
              "preview",
              documentInfo.documentInfo
            ) && (
              <Tooltip message={t("file.action.open")}>
                <Button
                  btnStyle={"icon"}
                  size="sm"
                  leadingIcon={<Icons variant="line" label="preview" isOn />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDocPreview({
                      permission: "view",
                      workgroupId:
                        documentInfo.documentInfo.workgroup.workgroupId,
                      syncId: documentInfo.documentInfo.syncId,
                      toast,
                      t,
                      revisionNo: 0,
                    });
                  }}
                />
              </Tooltip>
            )}
            <Tooltip message={t("file.action.download")}>
              <Button
                btnStyle={"icon"}
                size="sm"
                leadingIcon={<Icons variant="line" label="download" />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDocDownload(
                    documentInfo.documentInfo.syncId,
                    getContentDownload,
                    toast,
                    t,
                    "0",
                    documentInfo.documentInfo.contentName
                  );
                }}
              />
            </Tooltip>
            <Tooltip message={t("file.action.shareLink")}>
              <Button
                btnStyle={"icon"}
                size="sm"
                leadingIcon={<Icons variant="line" label="link" />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyLink();
                }}
              />
            </Tooltip>
            {utilsCommon.checkMenuAvailble(
              "auth",
              documentInfo.documentInfo
            ) && (
              <Tooltip message={t("file.action.auth")}>
                <Button
                  btnStyle={"icon"}
                  size="sm"
                  leadingIcon={<Icons variant="line" label="access" />}
                  onClick={(e) => {
                    e.stopPropagation();
                    changeModalType("SET_AUTH");
                  }}
                />
              </Tooltip>
            )}
            {utilsCommon.checkMenuAvailble(
              "requestOpen",
              documentInfo.documentInfo
            ) && (
              <Tooltip message={t("file.action.requestOpen")}>
                <Button
                  btnStyle={"icon"}
                  size="sm"
                  leadingIcon={<Icons variant="line" label="alertCircle" />}
                  onClick={(e) => {
                    e.stopPropagation();
                    changeModalType("READ_REQUEST");
                  }}
                />
              </Tooltip>
            )}
          </Box>
        )}
      </Box>
      <Box width={"100%"} height={"calc(100% - 66px)"}>
        <Box direction="column" width={"calc(100% - 276px)"}>
          <Typography type="subtitle2">{t("file.comment")}</Typography>
          <LeaveCommentModal
            open
            onClose={() => console.log("")}
            isTypeModal={false}
            docInfo={documentInfo.documentInfo}
            height={"calc(100% - 20px)"}
          />
        </Box>
        <DocAside
          isPreview
          page="clientDocDetail"
          asideInfo={{
            syncId: documentInfo.documentInfo.syncId,
            revisionNo: documentInfo.documentInfo.revisionNo,
            workgroupId: documentInfo.documentInfo.workgroup.workgroupId,
            contentName: documentInfo.documentInfo.contentName,
            documentInfo: documentInfo,
          }}
        />
      </Box>
    </Box>
  ) : (
    <Progress inProgress />
  );
};

export default ClientDocDetailModal;
